// API helpers for the shared bed census (ADR 0001 epic) — used by both
// BedAllocation.js and the nurse dashboard's BedDashboard.js.
import axios from "axios";

const BASE =
  process.env.REACT_APP_BACKEND_ROUTE_URL ||
  "https://manage-dev.hlthtek.com/app/api/";

function authHeaders() {
  const token = sessionStorage.getItem("accessToken") || "";
  return { Authorization: `Bearer ${token}` };
}

// filters: { bed_type_code, status, ward, room, room_category }
export async function getCensusBeds(filters = {}) {
  const params = new URLSearchParams();
  Object.entries(filters).forEach(([key, value]) => {
    if (value) params.set(key, value);
  });
  const qs = params.toString();
  const res = await axios.get(`${BASE}ipd_bed/${qs ? `?${qs}` : ""}`, {
    headers: authHeaders(),
  });
  return res?.data?.data || [];
}

// "Allocated" (not "Admitted") is the status for a patient who currently
// occupies a bed — see manage_bed_allocation.py:325. "Admitted" means
// registered but not yet allocated a bed (the allocation worklist's concern).
export async function getBedOccupants() {
  const res = await axios.get(`${BASE}ipd_admission/?status=Allocated`, {
    headers: authHeaders(),
  });
  return res?.data?.data || [];
}
